import { DROPOFF, PICKUP } from '../../../constants';

export const getWaypointFormValues = (
  waypoints: (RideDetailsWaypoint & Pick<WaypointFormType, 'riderAssistants'>)[] = []
): WaypointFormType[] => {
  const allRiders = waypoints.flatMap((waypoint) => waypoint.riders);

  return waypoints
    .filter((waypoint) => !waypoint.riderAssistants?.length)
    .map((waypoint) => ({
      anchor: waypoint.anchor,
      location: { ...waypoint.location },
      slug: waypoint.slug || '',
      passengerIds: waypoint.anchor ? allRiders.map((rider) => rider.slug) : waypoint.riders.map((rider) => rider.slug),
    }));
};

// Use this object to look up wording to use for waypoint labels, we can use the index to determine what to render.
export const helpers = {
  [PICKUP]: {
    getRALabel: () => 'Drop-off',
    getWaypointTitle: (index) => (index ? 'Drop off' : 'Pick up all Riders at'),
    getWaypointType: (index) => (index ? DROPOFF : PICKUP),
    isAnchor: (index) => !index,
    isNextToAnchor: (index) => index === 1,
    getLocationInputPlaceholder: (index) => (index ? 'Select Drop-off Location...' : 'Select Pickup Location...'),
    getRiderInputPlaceholder: (index) => (index ? 'Add Rider to Drop-off...' : 'Add Rider to Pickup...'),
    isDraggable: (index, waypointCount) => waypointCount > 2 && index > 0,
  },
  [DROPOFF]: {
    getRALabel: () => 'Pickup',
    getWaypointTitle: (index, waypointCount) => (index + 1 === waypointCount ? 'Drop off all Riders at' : 'Pickup'),
    getWaypointType: (index, waypointCount) => (index + 1 === waypointCount ? DROPOFF : PICKUP),
    isAnchor: (index, waypointCount) => index + 1 === waypointCount,
    isNextToAnchor: (index, waypointCount) => index + 2 === waypointCount,
    getLocationInputPlaceholder: (index, waypointCount) =>
      index + 1 === waypointCount ? 'Select Drop-off Location...' : 'Select Pickup Location...',
    getRiderInputPlaceholder: (index, waypointCount) =>
      index + 1 === waypointCount ? 'Add Rider to Drop-off...' : 'Add Rider to Pickup...',
    isDraggable: (index, waypointCount) => index + 1 !== waypointCount && waypointCount > 2,
  },
};
